import { FC } from 'react';
import { State } from 'redux/initialState';

import { useSelector } from 'react-redux';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';
import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';

import ContributionTableHeader from './ContributionTableHeader';
import ContributionTableBody from './ContributionTableBody';
import { useContributionModal } from '../context/ContributionModalContext';

const ContributionTable: FC = () => {
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const { data, actions } = useContributionModal();

  const totalItems =
    (actualSociety?.partnersCount?.active || 0) +
    (actualSociety?.partnersCount?.usufructuaries || 0);

  return (
    <>
      {data.isLoadingContributions ? (
        <TableSkeleton
          rows={9}
          columns={3}
          showSubHeader={false}
          cardInner={false}
          height={446}
        />
      ) : (
        <div
          className="card card-bordered card-preview"
          style={{ height: '446px' }}
        >
          <table className="table table-tranx" id="contribution-table">
            <ContributionTableHeader />
            <ContributionTableBody />
          </table>
        </div>
      )}

      <DataTablePagination
        itemPerPage={data.rowsPerPage || 10}
        totalItems={totalItems || 0}
        paginate={actions.handleChangePage}
        currentPage={data.currentPage}
        onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        customItemPerPage={0}
        setRowsPerPage={() => {}}
      />
    </>
  );
};

export default ContributionTable;
